(() => {
  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
  const lerp = (a, b, t) => a * (1 - t) + b * t;
  const easeInOutCubic = (x) =>
    x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;

  // Map root -> controller
  const controllers = new WeakMap();

  function getScrollParent(el) {
    let parent = el.parentElement;
    while (parent && parent !== document.body) {
      const style = getComputedStyle(parent);
      const overflowY = style.overflowY;
      if (
        (overflowY === "auto" || overflowY === "scroll") &&
        parent.scrollHeight > parent.clientHeight
      ) {
        return parent;
      }
      parent = parent.parentElement;
    }
    return window; // fallback
  }

  function init(root) {
    if (!root || controllers.has(root)) return;

    // Option de désactivation (si tu la gardes côté Liquid)
    if (root.dataset.enableAnimation === "false") return;

    const spoon = root.querySelector(".onefood-nutrients__spoon-img--mobile") && window.matchMedia("(max-width: 768px)").matches
  ? root.querySelector(".onefood-nutrients__spoon-img--mobile")
  : root.querySelector(".onefood-nutrients__spoon-img--desktop");

    if (!spoon) return;

    let rafId = null;
    let loopId = null;
    let inView = false;

    // Poses par défaut (plus proches du rendu voulu)
 const cfg = {
  // Pose 1 (image 1)
  rotStart: -12,
  xStart: 0,
  yStart: 0,

  // Pose 2 (image 2)
  rotMid: -28,
  xMid: -6,
  yMid: 10,

  // Pose 3 (image 3)
  rotEnd: -95,
  xEnd: -38,
  yEnd: 18
};


    function readVars() {
      const styles = getComputedStyle(root);
      const getVar = (name, fallback) => {
        const v = styles.getPropertyValue(name).trim();
        return v ? parseFloat(v) : fallback;
      };

      cfg.rotStart = getVar("--spoon-rot-start", cfg.rotStart);
      cfg.rotMid   = getVar("--spoon-rot-mid", cfg.rotMid);
      cfg.rotEnd   = getVar("--spoon-rot-end", cfg.rotEnd);

      cfg.xStart = getVar("--spoon-x-start", cfg.xStart);
      cfg.xMid   = getVar("--spoon-x-mid", cfg.xMid);
      cfg.xEnd   = getVar("--spoon-x-end", cfg.xEnd);

      cfg.yStart = getVar("--spoon-y-start", cfg.yStart);
      cfg.yMid   = getVar("--spoon-y-mid", cfg.yMid);
      cfg.yEnd   = getVar("--spoon-y-end", cfg.yEnd);
    }

    function apply(rot, x, y) {
      spoon.style.transform = `translate3d(${x}px, ${y}px, 0) rotate(${rot}deg)`;
    }

function tick() {
  rafId = null;

  const rect = root.getBoundingClientRect();
  const vh = window.innerHeight || document.documentElement.clientHeight;
  const h = Math.max(1, rect.height);

  const viewportMid = vh * 0.55;
  const raw = (viewportMid - rect.top) / h;
  const p = clamp(raw, 0, 1);
  const t = easeInOutCubic(p);

  // 3 poses façon tes images (angles modérés, ne sortent pas du champ)
  const a1 = 30;  // position 1
  const a2 = 60;  // position 1
  const a3 = 70;  // position 2
  const a4 = 38;  // position 3 (moins violent que -95)
  const a5 = 48;


  let angle;
  if (t <= 0.5) {
    const tt = t / 0.5;
    angle = lerp(a1, a2, tt);
  } else {
    const tt = (t - 0.5) / 0.5;
    angle = lerp(a2, a3, tt);
  }

  spoon.style.transform = `rotate(${angle}deg)`;
}



    function requestTick() {
      if (rafId) return;
      rafId = requestAnimationFrame(tick);
    }

   function onResize() {
  readVars();
  // Re-pick spoon on breakpoint change
  spoon = window.matchMedia("(max-width: 768px)").matches
    ? root.querySelector(".onefood-nutrients__spoon-img--mobile")
    : root.querySelector(".onefood-nutrients__spoon-img--desktop");
  requestTick();
}


    // IMPORTANT: scroll parent (mobile themes)
    const scrollParent = getScrollParent(root);

    function onAnyScroll() {
      requestTick();
    }

    // Loop rAF quand visible (fiable mobile même si scroll event capricieux)
    function loop() {
      if (!inView) return;
      requestTick();
      loopId = requestAnimationFrame(loop);
    }

    // IntersectionObserver (fallback: toujours true si non supporté)
    let io = null;
    if ("IntersectionObserver" in window) {
      io = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          inView = !!(entry && entry.isIntersecting);
          if (inView) {
            if (!loopId) loop();
          } else {
            if (loopId) {
              cancelAnimationFrame(loopId);
              loopId = null;
            }
          }
        },
        { threshold: 0.01 }
      );
      io.observe(root);
    } else {
      inView = true;
      loop();
    }

    // Init
    readVars();
    requestTick();

    // Écoute "large" (window + scroll parent + touchmove)
    window.addEventListener("scroll", onAnyScroll, { passive: true });
    window.addEventListener("resize", onResize, { passive: true });

    if (scrollParent && scrollParent !== window) {
      scrollParent.addEventListener("scroll", onAnyScroll, { passive: true });
    }

    // iOS: parfois le scroll “réel” est déclenché via touchmove
    document.addEventListener("touchmove", onAnyScroll, { passive: true });

    controllers.set(root, {
      destroy() {
        window.removeEventListener("scroll", onAnyScroll);
        window.removeEventListener("resize", onResize);

        if (scrollParent && scrollParent !== window) {
          scrollParent.removeEventListener("scroll", onAnyScroll);
        }
        document.removeEventListener("touchmove", onAnyScroll);

        if (io) io.disconnect();
        if (loopId) cancelAnimationFrame(loopId);
        if (rafId) cancelAnimationFrame(rafId);

        controllers.delete(root);
      }
    });
  }

  function boot() {
    document.querySelectorAll("[data-onefood-nutrients]").forEach(init);
  }

  document.addEventListener("DOMContentLoaded", boot);
  window.addEventListener("pageshow", boot);
  document.addEventListener("shopify:section:load", boot);
})();
